/* eslint-disable import/first */
import React, { useState } from 'react';
/* eslint-disable import/first */
const { useSelector, useDispatch } = Redux;

import ClassNames from 'classnames';
import {
  generateCustomization,
  getVariantDetails,
  decimalChecker,
} from 'spwa-ui-library/esm/utils/helper';
import { generateProductRoute } from 'spwa-ui-library/esm/utils/path';
import ProductName from './ProductName';
import AddtoCart from './AddToCart';
import ProductTilePrice from './ProductTilePrice';
import ProductTileImage from './ProductTileImage';
import CustomizedBox from './CustomizedBox';
import DrawerPwa from '../DrawerPwa';
import css from './index.module.scss';
import { BsChevronDoubleDown } from '@react-icons/all-files/bs/BsChevronDoubleDown';
import {
  addToCartGA,
  removeFromCartGA,
  removeItemGA,
  trackingAddedToCartGA,
} from 'spwa-ui-library/esm/utils/helperGA.js';
import ConfirmDeleteDialog from './ConfirmDeleteDialog';
import BackButton from '../BackButton';
import { Redux, Slices } from 'spwa-ui-library';
import DialogBox from '../DialogBox';
const { selectDesktop } = Slices.appSlice;
const { selectProductEntities } = Slices.productSlice;
const { selectCurrentCountry } = Slices.profileSlice;
const { reduceItem, increaseItem } = Slices.cartSlice;
const { selectDefaultAddress } = Slices.addressSlice;
const { selectBaseURL, selectCountryValidations } = Slices.configSlice;
import { FormattedMessage, useIntl } from 'react-intl';
import OfferTag from './images/OfferTag';
import { useLocation, useNavigate } from '@reach/router';
import { Button, Divider } from '@material-ui/core';
import classNames from 'classnames';
const { getProductInfo } = Slices.productSlice;
const { updateProductPayload, getBundleCustomisedList } = Slices.tempCartSlice;
const { getClusterId } = Slices.configSlice;

export default function ProductTileCart({
  miniCart,
  cartIndex,
  className,
  productObj,
  onCustomize,
  handleDelete,
  menuItem,
  isFreeItem,
  isDiscountedItem,
  cartPromo,
  cartItem,
  setTileError,
  setErrorState,
}) {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const isDesktop = useSelector(selectDesktop);
  const [showConfirmDeleteDialog, setShowConfirmDeleteDialog] = useState(false);
  const categoryInfo = useSelector((state) => state.category);
  const address = useSelector(selectDefaultAddress);
  const clusterId = useSelector(getClusterId);
  const cartState = useSelector((state) => state.cart);
  const [isCustomizeOpen, setCustomizeOpen] = useState(false);
  const [openViewDetailsPopup, setOpenViewDetailsPopUp] = useState(0);
  const country = useSelector(selectCurrentCountry).toString().toLowerCase();
  const thumbnail = productObj?.assets?.[0]?.src || cartItem.assets?.[0]?.src;
  const productsMap = useSelector(selectProductEntities);
  const bundleList = useSelector(getBundleCustomisedList);
  const intl = useIntl();

  const cartItems = useSelector((state) => state.cart);
  const productCustomization = cartItems.data.items[cartIndex];
  let tempProductCustomization = JSON.parse(JSON.stringify(cartItem));

  if (productObj?.isBOGO) {
    tempProductCustomization['typeId'] = 'bundle';
    tempProductCustomization['id'] = tempProductCustomization['catId'];
    tempProductCustomization['catId'] = tempProductCustomization['additionalInfo']?.['catId'];
    tempProductCustomization['bundle'] =
      tempProductCustomization?.['additionalInfo']?.['bundle'] || {};
    for (let [step, prod] of Object.entries(tempProductCustomization['bundle'])) {
      if (!prod?.items) {
        let stepInfo = tempProductCustomization?.subItem?.find((s) => s?.stepId == step);
        let productId = Object.keys(prod)[0];
        tempProductCustomization['bundle'][step][productId]['items'] = stepInfo?.items || {};
      }
    }
  } else if (productObj?.bundleTypeId == 'bundle' && productObj?.typeId == 'simple') {
    tempProductCustomization['bundle'] = tempProductCustomization['items'];
    tempProductCustomization['typeId'] = 'bundle';
    delete tempProductCustomization['items'];
  } else if (
    productObj?.bundleTypeId == 'bundle_group' ||
    cartItem?.additionalInfo?.bundleGroupId
  ) {
    let bundleId = cartItem?.id;
    tempProductCustomization['typeId'] = 'bundle';
    tempProductCustomization['id'] =
      cartItem?.additionalInfo?.bundleGroupId || cartItem['parentId'];
    tempProductCustomization['additionalInfo'] = {
      selectedBundleId: bundleId,
    };

    if (cartItem?.additionalInfo?.bundleGroupId) {
      tempProductCustomization['additionalInfo']['bundleGroupId'] =
        cartItem?.additionalInfo?.bundleGroupId;
    }
  }

  const checkProductPrice = () => {
    if (productObj?.typeId?.includes('bundle')) {
      return productObj?.price >= 0
        ? productObj?.price
        : productObj?.specialPrice || productObj?.originalPrice || 0;
    }

    let productVariationsArray = [-1, -1, -1];

    Object.values(productCustomization?.variants || {}).forEach((variant, index) => {
      productVariationsArray[index] = variant;
    });

    if (productObj?.items && productObj?.items.length) {
      let item = productObj?.items.find((element) => {
        const newElement = element.id ? element.id : element;

        let isVariantSame = true;
        productVariationsArray.forEach((variant, index) => {
          if (productsMap?.[newElement]?.[`sel${index + 1}Value`] != variant) {
            isVariantSame = false;
          }
        });
        return isVariantSame;
      });

      if (!item?.id) {
        item = productsMap[item];
      }
      return item?.price >= 0 ? item?.price : item?.specialPrice || item?.originalPrice || 0;
    }

    return productObj?.price >= 0
      ? productObj?.price
      : productObj?.specialPrice || productObj?.originalPrice || 0;
  };

  let other = [];
  if (cartItem?.errMsg && cartItem?.errMsg !== '') {
    setErrorState(true);
    setTileError(cartItem?.errMsg);
  }
  menuItem &&
    menuItem.items &&
    menuItem.items.length &&
    menuItem.items.forEach((inner) => {
      other.push(productsMap[inner]);
    });

  const ItemCustomize = { ...menuItem, items: other };
  const customizeDescription = generateCustomization(productObj, ItemCustomize);
  const strikeOutPrice = productObj?.strikeOutPrice || 0;
  const discountPercentage = productObj?.discountPercentage || 0;
  const sellingPrice =
    productCustomization?.price || productObj?.specialPrice || productObj?.originalPrice;

  const bogoOriginalPrice = cartItem?.price / (cartItem?.qty || 1);

  const productPrice = checkProductPrice() || bogoOriginalPrice;
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const currency = countryValidations && countryValidations.currency;
  const currencyIcon = currency ? currency : 'AED';
  let categorySelected;
  for (let category of productObj?.categories || []) {
    let data = categoryInfo.entities[category];
    if (data) {
      categorySelected = data;
      break;
    }
  }

  // IS DETAILS VISIBLE BOOLEAN
  const isDetailsVisible = productObj?.bundleTypeId !== 'simple';

  // HANDLE INCREMENT METHOD FOR CART ITEMS
  const handleIncrement = (e) => {
    let newItems = [...cartState.data.items];
    newItems = newItems.map((item) => {
      if (item.id == cartIndex) {
        item['qty'] = item['qty'] + 1;
      }
      return item;
    });

    e.preventDefault();
    addToCartGA(productObj, currency, categorySelected?.name, 'ProductCartPage');
    trackingAddedToCartGA(productObj, currency, categorySelected?.name, address);
    dispatch(increaseItem({ id: cartIndex }));
  };

  // HANDLE DECREMENT METHOD FOR CART ITEMS
  const handleDecrement = (e) => {
    e.preventDefault();
    if (!productCustomization?.qty || productCustomization?.qty == 1) {
      setShowConfirmDeleteDialog(true);
    } else {
      removeFromCartGA(productObj, currency, categorySelected, 'ProductCartPage');
      removeItemGA(productObj, currency, categorySelected);
      dispatch(reduceItem({ index: cartIndex }));
    }
  };
  // STRIK PRICE
  let strickPrice;
  if (isFreeItem) {
    strickPrice = true;
  } else if (isDiscountedItem) {
    strickPrice = productObj?.finalPrice;
  } else {
    strickPrice = productObj?.originalPrice !== sellingPrice ? 0 : strikeOutPrice;
  }

  const handleViewDetailsPopUp = (id) => {
    setOpenViewDetailsPopUp((prev) => id);
  };

  const handleEditButton = () => {
    window.localStorage.setItem('notShowBogoPopup', true);
    dispatch(
      getProductInfo({
        id: productObj?.id,
        cluster: clusterId,
        service: address?.addressSubType || 'DELIVERY',
        categoryId: productObj?.categories[0],
        Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
      })
    ).then(() => {
      let productRoute = generateProductRoute({
        product: productObj,
        category: categorySelected,
        locale: intl.locale.toLowerCase(),
      });

      let routeOptions = '';
      if (productObj?.isBOGO) {
        let bundleKey = parseInt(Object.keys(tempProductCustomization?.bundle || {})[0]);
        const optionId = (bundleKey - (bundleKey % 10)) / 10;
        routeOptions = `&bundleGroup=1&option=${optionId}`;

        tempProductCustomization = JSON.parse(JSON.stringify(tempProductCustomization));

        for (let [stepId, stepProd] of Object.entries(tempProductCustomization?.bundle)) {
          for (let [prodId, prodData] of Object.entries(stepProd || {})) {
            if (!prodData?.items) {
              let data = tempProductCustomization?.subList?.find(
                (sItem) => sItem?.id == prodId && sItem?.isDefault == prodData?.isDefault
              );
              if (data) {
                tempProductCustomization['bundle'][stepId][prodId]['items'] = data?.items || {};
              }
            }
          }
        }

        dispatch(
          updateProductPayload({
            data: {
              ...tempProductCustomization,
              qty: productCustomization?.qty || 1,
              price: productCustomization?.price,
            },
          })
        );
      } else {
        dispatch(updateProductPayload({ data: tempProductCustomization }));
      }

      if (tempProductCustomization?.additionalInfo?.selectedBundleId && !productObj?.isBOGO) {
        // handle wingstreet, wow tripes etc.
        let mainProductInfo = productsMap[tempProductCustomization?.id];
        let mainProductCategory = categoryInfo.entities[mainProductInfo?.categories?.[0]];

        productRoute = generateProductRoute({
          product: mainProductInfo,
          category: mainProductCategory,
          locale: intl.locale.toLowerCase(),
        });
        routeOptions = `&bundleGroup=1&option=${productObj?.sel1Value}`;
      }

      // update product info in tempCart/data from cart.
      // dispatch(updateProductPayload({ data: productCustomization }));

      if (productObj['bundleTypeId'] == 'configurable' || productObj?.typeId == 'simple') {
        navigate(`${productRoute}?cartId=${cartIndex}${routeOptions}`, {
          state: {
            oldLocation: JSON.parse(JSON.stringify(location)),
            description: intl.formatMessage({ id: 'customize_your_meals' }),
          },
        });
      } else {
        // bundle or bundle_group
        navigate(`${productRoute}/bundle?cartId=${cartIndex}${routeOptions}`, {
          state: {
            oldLocation: JSON.parse(JSON.stringify(location)),
          },
        });
      }
    });
  };

  const renderBundleItem = (item) => {
    return (
      <div className={css.bundleStepItem}>
        <div className={css.renderTitle}>{item.productName}</div>
        <span className={css.productPrice}>{`${
          productPrice || cartItem.specialPrice
        } ${currency}`}</span>
        {item.productDescription && (
          <div className={css.viewDetailsDescription}>{item.productDescription}</div>
        )}
        {item.variantsInfo && <div className={css.bundleStepVariation}>{item.variantsInfo}</div>}
        {item.items &&
          item.items.map((innerItem, idx) => (
            <div key={idx} className={css.bundleStepItem}>
              {innerItem.itemTitle && (
                <div className={css.bundleStepProductName}>{`${idx + 1}. ${
                  innerItem.itemTitle
                }`}</div>
              )}
              {/* Render other properties for inner items */}
              {innerItem.variantsInfo && (
                <div className={css.bundleStepVariation}>{innerItem.variantsInfo}</div>
              )}
              {innerItem.addedProductItems && innerItem.additionPrice >= 0 && (
                <div className={css.bundleStepAdded}>
                  <div className={css.row1}>
                    <span className={css.greenText}>
                      <FormattedMessage id="added" defaultMessage="Added" /> :
                    </span>
                    {`${innerItem.addedProductItems}`}
                  </div>
                  <div className={css.row2}>
                    <span className={css.greenText}>{`+${decimalChecker(
                      innerItem.additionPrice
                    )} ${currency}`}</span>
                  </div>
                </div>
              )}
              {innerItem.removedProductItems && (
                <div className={css.bundleStepRemoved}>
                  <span className={css.redText}>
                    <FormattedMessage id="removed" defaultMessage="Removed" /> :
                  </span>
                  {` ${innerItem.removedProductItems}`}
                </div>
              )}
            </div>
          ))}
      </div>
    );
  };
  const RenderSubitems = () => {
    let subItems = JSON.parse(JSON.stringify(cartItem?.subItem || []));
    if (
      (subItems[0]?.specialPrice || subItems[0]?.originalPrice || 0) ==
      (subItems[1]?.specialPrice || subItems[1]?.originalPrice || 0)
    ) {
      subItems.sort((item1, item2) => item2.price - item1.price);
    } else {
      subItems.sort(
        (item1, item2) =>
          (item2?.specialPrice || item2?.originalPrice) -
          (item1?.specialPrice || item1?.originalPrice)
      );
    }

    return (
      <>
        {subItems?.map((itm, idx) => {
          return (
            // <div className={css.bogoHeading}>{idx}. </div>
            <RenderConfigurable bogo={true} idx={idx} val={itm?.editDesc?.[0]} />
          );
        })}
      </>
    );
  };
  const RenderDetailView = ({ val, idx }) => {
    return (
      <>
        <div className={css.editItem}>
          {val.title && val.title !== '' && (
            <div
              className={classNames({
                [css.isAddOns]:
                  (val.addons && decimalChecker(val?.price) > 0) ||
                  (val.qty &&
                    decimalChecker(val?.defaultPrice) > 0 &&
                    decimalChecker(val?.price) > 0) ||
                  decimalChecker(val.extraBasePrice) > 0,
              })}
            >
              <div className={css.title}>
                <span>{idx}.</span>
                {val?.title}
              </div>
              <div
                className={classNames(
                  {
                    [css.added]:
                      (val.addons && decimalChecker(val?.price) > 0) ||
                      (val.qty && decimalChecker(val?.defaultPrice) > 0 && !val?.added),
                  },
                  { [css.isExtraAdded]: decimalChecker(val.extraBasePrice) > 0 }
                )}
              >
                {decimalChecker(val.extraBasePrice) > 0
                  ? `+${decimalChecker(val.extraBasePrice)} ${currency}`
                  : ''}
                {(val.addons && decimalChecker(val?.price) > 0) ||
                (val.qty &&
                  decimalChecker(val?.defaultPrice) > 0 &&
                  decimalChecker(val?.price) > 0 &&
                  !val?.added) ? (
                  <div className={css.addedPrice}>
                    + {decimalChecker(val?.price)} {currency}
                  </div>
                ) : (
                  ''
                )}
              </div>
            </div>
          )}
          {val.subtitle && val.subtitle !== '' && (
            <div className={css.subTitle}>{val?.subtitle}</div>
          )}

          {val.added && val.added !== '' && (
            <div className={css.added}>
              <div className={css.addedDesc}>
                <span>
                  <FormattedMessage id="added" defaultMessage="Added" />
                </span>{' '}
                -{val?.added}
              </div>
              {val?.price !== 0 ? (
                <div className={css.addedPrice}>
                  + {decimalChecker(val?.price)} {currency}
                </div>
              ) : (
                ''
              )}
            </div>
          )}
          {val.removed && val.removed !== '' && (
            <div className={css.bundleStepRemoved}>
              <span className={css.redText}>
                <FormattedMessage id="removed" defaultMessage="Removed" /> :
              </span>
              {` ${val.removed}`}
            </div>
          )}
        </div>
        <Divider className={css.divider} />
      </>
    );
  };
  const RenderConfigurable = ({ val, bogo = false, idx }) => {
    if (!val) {
      return '';
    }

    return (
      <>
        {val.title && val.title !== '' && bogo && (
          <div className={css.bogotitle}>
            <span>{idx + 1}.</span>
            <span className={css.bogoName}>{val?.title}</span>
            <span className={classNames(css.bogoPrice, idx === 1 ? css.strikePrice : '')}>
              {decimalChecker(val.defaultPrice)} {currency}
            </span>
          </div>
        )}
        <div className={classNames(css.editItem, css.simpleProd)}>
          {val.subtitle && val.subtitle !== '' && (
            <div className={css.subTitle}>{val?.subtitle}</div>
          )}
          {val.description && val.description !== '' && !bogo && (
            <div className={css.descriptionValue}>{val.description}</div>
          )}

          {val.added && val.added !== '' && (
            <div className={css.added}>
              <div className={css.addedDesc}>
                <span>
                  <FormattedMessage id="added" defaultMessage="Added" />
                </span>{' '}
                -{val?.added}
              </div>
              {val?.price !== 0 ? (
                <div className={css.addedPrice}>
                  + {decimalChecker(val?.price)} {currency}
                </div>
              ) : (
                ''
              )}
            </div>
          )}
          {val.removed && val.removed !== '' && (
            <div className={css.bundleStepRemoved}>
              <span className={css.redText}>
                <FormattedMessage id="removed" defaultMessage="Removed" /> :
              </span>
              {` ${val.removed}`}
            </div>
          )}
        </div>
        <Divider className={css.divider} />
      </>
    );
  };
  const renderDetail = () => {
    if (!cartItem?.editDesc?.length && !cartItem?.subItem) {
      return '';
    }

    return (
      <div className={css.bundleStepItem}>
        <div className={css.renderTitle}>{productObj?.name}</div>
        <span className={css.productPrice}>{`${decimalChecker(
          productPrice || cartItem.specialPrice
        )} ${currency}`}</span>

        {cartItem.typeId !== 'bundle' && !cartItem?.subItem ? (
          cartItem?.editDesc?.map((val) => {
            return <RenderConfigurable val={val} />;
          })
        ) : cartItem?.editDesc && !cartItem?.subItem ? (
          cartItem?.editDesc.map((val, idx) => {
            if (idx === 0) return '';
            else {
              return <RenderDetailView val={val} idx={idx} />;
            }
          })
        ) : (
          <>
            <RenderSubitems />
          </>
        )}
      </div>
    );
  };
  const RenderViewCartContent = () => {
    return (
      <>
        {!isDesktop && (
          <div className={css.btnStyle}>
            <BackButton type="cross" handleBack={() => setOpenViewDetailsPopUp(0)} />
          </div>
        )}
        <div className={css.viewDetailsDialogContent}>
          <div className={css.detailsContainer}>
            <div className={css.innerWrapperDetails}>
              {/* Render other properties */}
              {!cartItem?.editDesc?.length && productObj?.bundleTypeId == 'simple' && (
                <div className={css.viewDetailsDescription}>{productObj.description}</div>
              )}
              {cartItem?.editDesc?.length || cartItem?.subItem?.length
                ? renderDetail()
                : bundleList
                    .filter((item) => item.productId === openViewDetailsPopup)
                    .map((item, idx) => (
                      <React.Fragment key={idx}>
                        {renderBundleItem(item)}
                        <Divider />
                      </React.Fragment>
                    ))}
            </div>
          </div>
          <div
            className={classNames(css.actionButtons, {
              [css.spaceBetween]: location.pathname.includes('cart'),
            })}
          >
            {productObj?.['bundleTypeId'] != 'simple' && location.pathname.includes('cart') && (
              <Button
                className={css.editButton}
                onClick={handleEditButton}
                variant="outlined"
                color="secondary"
              >
                <FormattedMessage id={'edit'} defaultMessage={'Edit'} />
              </Button>
            )}
            <Button
              className={css.closeButton}
              onClick={() => {
                handleViewDetailsPopUp(0);
              }}
              variant="outlined"
              color="primary"
            >
              <FormattedMessage id={'close'} defaultMessage={'Close'} />
            </Button>
          </div>
        </div>
      </>
    );
  };
  // debugger;
  const priceOfItem = isDiscountedItem
    ? sellingPrice - cartPromo?.discountAmount
    : sellingPrice || cartItem.price;
  return (
    <>
      <div
        className={ClassNames(
          css.root,
          { [className]: className },
          { [css.handleMiniCart]: miniCart },
          { [css.notMini]: !miniCart },
          { opened: isCustomizeOpen }
        )}
      >
        {
          // TODO: add scenerio for multiple images
        }
        <div className={css.productInfo}>
          <ProductTileImage
            imageSrc={thumbnail}
            productName={productObj?.name}
            handleCart={() => {}}
          />
          <div className={ClassNames(css.title)}>
            <div
              className={ClassNames(css.productTitle, {
                [css.titleSpan]: location.pathname.includes('cart'),
              })}
            >
              <ProductName
                className={css.tileTitle}
                productName={productObj?.name || productObj?.title || cartItem?.name}
              />
              <h4
                className={`${css.tileDescription}${miniCart ? ` ${css.tileDescriptionMini}` : ''}`}
              >
                {getVariantDetails(productCustomization, productObj)}
              </h4>
            </div>
            <div className={css.productDescription}>
              {productObj && (
                <span
                  className={css.viewDetails}
                  onClick={() => handleViewDetailsPopUp(productObj?.id || cartItem?.id)}
                >
                  <FormattedMessage id={'view_details'} defaultMessage={'View Details'} />
                  <BsChevronDoubleDown />
                </span>
              )}
            </div>
          </div>
        </div>
        <div className={css.productCartHandle}>
          <ProductTilePrice
            discountPercentage={discountPercentage}
            strikeOutPrice={strickPrice}
            price={priceOfItem}
            currency={currencyIcon}
          />
          {!isFreeItem && !isDiscountedItem && (
            <AddtoCart
              qty={productCustomization.qty}
              onIncrement={handleIncrement}
              onDecrement={handleDecrement}
            />
          )}
        </div>
      </div>

      {isDiscountedItem && (
        <div className={css.offerAppliedContainer}>
          <div className={css.offerTag}>
            <OfferTag className={intl.locale === 'ar' ? css.rotateBadge : ''} />
            <span className={css.offerAppliedBox}>{<FormattedMessage id="offer_applied" />}</span>
          </div>
        </div>
      )}
      {/* {productObj.customized && ( */}
      <CustomizedBox
        className={ClassNames({ opened: isCustomizeOpen }, { [css.miniCartCustomize]: miniCart })}
        customizeDescription={customizeDescription}
        onCustomize={onCustomize}
        productObj={productObj}
      />

      {isDesktop && openViewDetailsPopup === productObj?.id ? (
        <DialogBox
          title={productsMap[openViewDetailsPopup]?.name}
          size="md"
          hideCloseButton
          leftAlign
          className={css.viewDetailsDialog}
          isOpen={openViewDetailsPopup === productObj?.id}
          onClose={() => setOpenViewDetailsPopUp(0)}
        >
          <RenderViewCartContent />
          {/* {renderViewCartContent()} */}
        </DialogBox>
      ) : (
        <DrawerPwa
          variant="temporary"
          anchor="bottom"
          open={openViewDetailsPopup == productObj?.id}
          className={css.drawer}
          onClose={() => setOpenViewDetailsPopUp(0)}
          hideCloseButton
        >
          <RenderViewCartContent />
          {/* {renderViewCartContent()} */}
        </DrawerPwa>
      )}
      {showConfirmDeleteDialog && (
        <ConfirmDeleteDialog
          setShowConfirmDeleteDialog={setShowConfirmDeleteDialog}
          handleDelete={() => handleDelete(cartIndex)}
          thumbnail={thumbnail}
        />
      )}
    </>
  );
}
